module.exports = __webpack_public_path__ + "img/main_home3.67c7a7a.png";